module.exports = {
    EXPIRED: 'expired',
    FAILED: 'failed',
};
